<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">

			</header>
		</div>
		<el-card class="operate-container" shadow="never">
			<i class="el-icon-tickets" style="margin-top: 5px"></i>
			<span style="margin-top: 5px">数据列表</span>
			<el-button type="primary" class="btn-add" @click="dialogVisiblefun()" size="mini"
				style="position: absolute;right:50px">
				添加
			</el-button>
		</el-card>
		<!-- 列表展示 -->
		<el-table :data="orderList.list" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>

			<el-table-column prop="name" label="类型名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="attributeCount" label="属性数量" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="paramCount" label="参数数量" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="设置" align="center" width="" :show-overflow-tooltip="true">
				<template v-slot="scope">
					<el-button @click="dialogTShow(scope.row)">属性列表</el-button>
					<el-button @click="dialogPShow(scope.row)">参数列表</el-button>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="" :show-overflow-tooltip="true">
				<template v-slot="scope">
					<el-button @click="dialogVisiblefun(scope.row.id)">编辑</el-button>
					<el-button type="danger" @click="deleteId(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="remark" label="备注" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->

		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="dialogVisible" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="类型名称">
						<el-col :span="12">
							<el-input type="text" v-model="formData.name" placeholder="请输入类型名称" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false;formData={}">取 消</el-button>
				<el-button type="primary" @click="revisePmsProductAttributeCategory" v-if="title=='编辑'" :loading="editLoading">确 定</el-button>
				<el-button type="primary" @click="addPmsProductAttributeCategory" v-if="title=='新增'" :loading="addLoading">新增</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderList: [],
				dialogVisible: false,
				dialogT: false,
				dialogP: false,
				searchInfo: {},
				orderInfo: {},
				sliderlist: {},
				// provinceList: [],
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				formData: {},
				formDateT: {},
				formDateP: {},
				title: '',

				editLoading: false,
				addLoading: false,
			};
		},
		methods: {
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()

			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				let data = {}
				this.$api.pmsProductAttributeCategoryList({}).then((res => {
					// console.log(res)
					if (res.state == 'success') {
						this.orderList = res.data
						// console.log(this.sliderlist)
					}
				}))
				//查询省
				// this.$api.getAreas(0).then((res) => {
				// 	// console.log(res)
				// 	if (res.state == 'success') {
				// 		this.provinceList = res.data
				// 		//  console.log(this.provinceList)
				// 	}
				// })
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				// this.setTLevelData.areaId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreas(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getAreas(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
			},
			deleteId(id) {
				this.$api.deletePmsProductAttributeCategory(id).then(res => {
					if (res.state == 'success') {
						this.$message.success(res.data)
						this.storeOrderList()
					}
				})
			},
			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			dialogTShow(row) {
				this.$router.push({
					path: '/goods/productAttrList',
					query: {
						id: row.id,
						type: 0
					}
				})
			},
			dialogPShow(row) {
				this.$router.push({
					path: '/goods/productAttrList',
					query: {
						id: row.id,
						type: 1
					}
				})
			},
			// 单个查询
			dialogVisiblefun(id) {
				this.dialogVisible = true
				this.formData = {}
				if (id) {
					this.title = '编辑'
					this.$api.pmsProductAttributeCategoryList({
						id
					}).then(res => {
						if (res.state == 'success') {
							this.formData = res.data.list[0]
						}
					})
				} else {
					this.title = '新增'
				}
			},
			// 编辑
			revisePmsProductAttributeCategory() {
				this.editLoading = true;
				this.$api.revisePmsProductAttributeCategory(this.formData).then(res => {
					if (res.state == 'success') {
						this.$message.success(res.data)
						this.dialogVisible = false
						this.storeOrderList()
					}
					this.editLoading = false;
				})
			},
			addPmsProductAttributeCategory() {
				this.addLoading = true;
				this.$api.addPmsProductAttributeCategory(this.formData).then(res => {
					if (res.state == 'success') {
						this.$message.success(res.data)
						this.dialogVisible = false
						this.storeOrderList()
					}
					this.addLoading = false;
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
		},

		created() {
			this.storeOrderList();
		},
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.operate-container {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>
